import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top whenever the route path changes.
 * Uses 'instant' behavior so navigation jumps to top immediately
 * (smooth scrolling is reserved for hash-link navigation within a page).
 * Must be rendered inside <Router>.
 */
export const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Skip when navigating to an in-page anchor — `useScrollToHash`
        // (or the browser) handles scrolling to the target section instead.
        if (hash) return;
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [pathname, hash]);

    return null;
};
